import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as forms } from 'redux-form';

import history from './history';

import ProductSearch from 'services/ProductSearch';
import experimentsReducer from 'shared/reducers/experiments';
import footer from 'shared/reducers/footer';
import device from 'shared/reducers/device';

import {
  appReducerKey,
  appReducer
} from 'screens/App/reducer';
import {
  reducerKey as customPropsReducerKey,
  reducer as customPropsReducer
} from 'screens/PPOMonarch/CustomPieces';
import {
  checkoutReducerKey,
  checkoutReducer
} from 'shared/components/Checkout/state';
import {
  DataReducers
} from 'services/Data';
import {
  featureFlagReducerKey,
  featureFlagReducer
} from 'shared/reducers/featureFlag';
import {
  studioReducerKey,
  studioReducer
} from 'redux/Studio';
import {
  registryReducerKey,
  registryReducer
} from 'shared/components/Registry';
import {
  retailPartnerReducerKey,
  retailPartnerReducer
} from 'shared/reducers/retailPartner';
import {
  ppoReducerKey,
  ppoReducer
} from 'redux/PPO';
import {
  debugReducerKey,
  debugReducer
} from 'redux/Debug';
import {
  authReducerKey,
  authReducer
} from 'redux/User';
import {
  addToCartFeedbackReducerKey,
  addToCartFeedbackReducer
} from 'shared/components/AddToCartFeedback';
import {
  reducer as settingsReducer,
  reducerKey as settingsReducerKey
} from 'screens/Account/Settings/state';
import {
  reducer as accountReducer,
  reducerKey as accountReducerKey
} from 'redux/Account';
import {
  messengerReducerKey,
  reducer as messengerReducer
} from 'redux/Messenger';

import * as tsReducers from '../ts/studio/reducers';

export default function createReducer (asyncReducers) {
  return combineReducers({
    [appReducerKey]: appReducer,
    [checkoutReducerKey]: checkoutReducer,
    [customPropsReducerKey]: customPropsReducer,
    [DataReducers.dataServiceReducerKey]: DataReducers.dataServiceReducer,
    [featureFlagReducerKey]: featureFlagReducer,
    [registryReducerKey]: registryReducer,
    [retailPartnerReducerKey]: retailPartnerReducer,
    footer,
    experiments: experimentsReducer,
    [debugReducerKey]: debugReducer,
    device: device,
    form: forms,
    router: connectRouter(history),
    [messengerReducerKey]: messengerReducer,
    [studioReducerKey]: studioReducer,
    [ppoReducerKey]: ppoReducer,
    [authReducerKey]: authReducer,
    [ProductSearch.reducerKey]: ProductSearch.reducer,
    [addToCartFeedbackReducerKey]: addToCartFeedbackReducer,
    [settingsReducerKey]: settingsReducer,
    [accountReducerKey]: accountReducer,
    ...tsReducers,
    ...asyncReducers
  });
}
